module.cC({
    name: 'ProgramIndexController',
    inject: ['$scope', 'ModelService', '$location', '$stateParams', '$state'],
    data: {
        tags: 'tags',
        pills : [
            {name: "Active", value: 'active'},
            {name: "Inactive", value: 'inactive'},
        ],
    },
    init: function() {
        this.params = this.$.params = {
            search: this.$stateParams.search,
            page: this.$stateParams.page,
            status: this.$stateParams.status,
            sort: this.$stateParams.sort,
            direction: this.$stateParams.direction,
            tagParams: {},
        };
    },
    watch: {
        '{object}params': '_refresh',
    },
    methods: {
        refreshTags: function(params) {
            this.$.params.tagParams = params;
        },
        _refresh: function(params, oldParams) {
            if (!params) return;

            if (oldParams.page === params.page && params.page !== 1) {
                params.page = 1;
                return;
            }

            var queryParams = angular.copy(params);
            angular.extend(queryParams, params.tagParams);
            delete queryParams.tagParams;

            // this.$state.go('programs', queryParams, {
            //     location: 'replace',
            //     inherit: false,
            // });
            this.ModelService.index('program', queryParams)
                .then(this._setPrograms);
        },
        _setPrograms: function(programs) {
            this.programs = programs;
        },
    }
});
